import axios from 'axios'
import { LoadingBar, Message } from 'iview'
import router from '../router/router'

function throwError (error, msg) {
  const res = error.response
  if (res) {
    if (res.status >= 400 && res.status < 500) {
      switch (res.status) {
        case 401: // 没有登录或者token失效
          errorMsg(error, msg)
          router.replace({name: 'login'})
          break
        case 403: // 没有权限
          errorMsg(error, msg)
          router.replace({name: '403'})
          break
        case 404:
          errorMsg(error, msg)
          router.push({name: '404'})
          break
        default:
          errorMsg(error, msg)
          break
      }
    } else if (res.status >= 500) {
      console.log(500)
      errorMsg(error, msg)
      router.push({name: '500'})
    }
  } else {
    Message.error('请求出现错误')
    router.push({name: '500'})
  }
}

function errorMsg (error, msg) {
  if (msg) {
    Message.error(msg)
  } else if (error.response.data.message) {
    Message.error(error.response.data.message)
  } else {
    Message.error(error.toString())
  }
}

/**
 * GET请求数据
 * @param {string} url - 请求的接口路径
 * @param {object} objectParams - 请求的参数对象
 * @param {string} [customMsg] - 自定义提示消息
 * @returns {Promise}
 * @deprecated
 */
export function doGetGeneral (url, objectParams, customMsg = '') {
  LoadingBar.start()
  return new Promise((resolve, reject) => {
    const instance = axios.create({
      baseURL: window.store.host,
      timeout: 5000000000000,
      headers: {
        'Authorization': 'bearer ' + window.localStorage['access_token'],
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    })
    const options = {
      url: url,
      method: 'get',
      params: objectParams
    }
    instance(options).then(response => {  // axios返回来结果
      LoadingBar.finish()
      const res = response.data
      resolve(res)
    }).catch(error => {
      LoadingBar.error()
      throwError(error, customMsg)
      reject(error)
    })
  })
}

/**
 * POST请求数据（URL参数方式）
 * @param {string} url - 请求的接口路径
 * @param {object} urlSearchParams - POST的参数，该参数是一个URLSearchParams对象
 * @param {string} [customMsg] - 自定义提示消息
 * @returns {Promise}
 * @deprecated
 */
export function doPostWithURLSearchParams (url, urlSearchParams, customMsg = '') {
  LoadingBar.start()
  return new Promise((resolve, reject) => {
    axios.post(url, urlSearchParams, {
      baseURL: window.store.host,
      timeout: 60000,
      headers: {
        'Authorization': 'bearer ' + window.localStorage['access_token']
      }
    }).then(function (response) {
      LoadingBar.finish()
      const res = response.data
      resolve(res)
    }).catch(function (error) {
      LoadingBar.error()
      throwError(error, customMsg)
      reject(error)
    })
  })
}

/**
 * POST请求数据（对象参数方式）
 * @param {string} url - 请求的接口路径
 * @param {object} objectParams - POST的参数，该参数是一个object对象
 * @param {string} [customMsg] - 自定义提示消息
 * @returns {Promise}
 * @deprecated
 */
export function doPostWithObjectParams (url, objectParams, customMsg = '') {
  LoadingBar.start()
  return new Promise((resolve, reject) => {
    const qs = require('qs')
    axios.post(url, qs.stringify(objectParams), {
      baseURL: window.store.host,
      timeout: 60000,
      headers: {
        'Authorization': 'bearer ' + window.localStorage['access_token']
      }
    }).then(function (response) {
      LoadingBar.finish()
      const res = response.data
      resolve(res)
    }).catch(function (error) {
      LoadingBar.error()
      throwError(error, customMsg)
      reject(error)
    })
  })
}

/**
 * POST请求数据（Content-Type: text/plain）
 * @param {string} url - 请求的接口路径
 * @param {string} strParams - 字符串参数
 * @param {string} [customMsg] - 自定义提示消息
 * @returns {Promise}
 * @deprecated
 */
export function doPostByTextPlain (url, strParams, customMsg = '') {
  LoadingBar.start()
  return new Promise((resolve, reject) => {
    axios.post(url, strParams, {
      baseURL: window.store.host,
      timeout: 60000,
      headers: {
        'Authorization': 'bearer ' + window.localStorage['access_token'],
        'Content-Type': 'text/plain'
      }
    }).then(function (response) {
      LoadingBar.finish()
      const res = response.data
      resolve(res)
    }).catch(function (error) {
      LoadingBar.error()
      throwError(error, customMsg)
      reject(error)
    })
  })
}

/**
 * 发起请求
 * @param {object} option - 请求的设置
 * @param {string} [customMsg] - 自定义提示消息
 * @returns {Promise}
 * @deprecated
 */
export function doRequest (option, customMsg = '') {
  LoadingBar.start()
  return new Promise((resolve, reject) => {
    const instance = axios.create({
      baseURL: window.store.host,
      timeout: 60000,
      headers: {
        'Authorization': 'bearer ' + window.localStorage['access_token'],
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    })
    const options = {
      url: option.url,
      method: option.method,
      params: option.params
    }
    instance(options).then(response => {  // axios返回来结果
      LoadingBar.finish()
      const res = response.data
      resolve(res)    // axios返回来的结果有效可用，则resolve这个结果给Promise实例
    }).catch(error => {
      LoadingBar.error()
      throwError(error, customMsg)
      reject(error)
    })
  })
}
